import { useMemo } from "react";

import {
  Dimensions,
  setSelectedCameraSkuSection,
  transformCoordinate,
} from "@/entities/planogram";
import { SkuSection, WithIndex } from "@/shared/api";
import { BasePolygon } from "./base-polygon";
import { useAppDispatch, useAppSelector } from "@/app/appStore";

type PolygonProps = {
  index: number;
  cameraSkuSection: WithIndex<SkuSection>;
  canvasDimensions: Dimensions;
  onSelect?: () => void;
};

export function Polygon({
  cameraSkuSection,
  canvasDimensions,
  onSelect,
}: PolygonProps) {
  const isSelected = useAppSelector(
    (state) =>
      cameraSkuSection.sku_section_id ===
      state.planogram.selectedCameraSkuSection?.sku_section_id
  );
  const dispatch = useAppDispatch();
  const points = useMemo(
    () =>
      cameraSkuSection.polygon_points.map((coordinates) =>
        transformCoordinate(...coordinates, canvasDimensions)
      ),
    [cameraSkuSection.polygon_points, canvasDimensions]
  );

  const onPointerDown = () => {
    dispatch(setSelectedCameraSkuSection({ cameraSkuSection }));

    onSelect?.();
  };

  return (
    <BasePolygon
      shadowForStrokeEnabled={false}
      isSelected={isSelected}
      points={points.flatMap((point) => point)}
      isEmpty={cameraSkuSection.sku_section_id === null}
      id={String(cameraSkuSection.id)}
      onPointerDown={onPointerDown}
      hoverEnabled
    />
  );
}
